module.exports = __webpack_public_path__ + "static/media/Team 30 - Logo - Đăng Khoa Lê.555cf463.jpeg";